import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>CONDITIONS GÉNÉRALES DE VENTE</h1>
        <h2>Personal Regrets</h2>
        
        <div className="terms-intro">
          <p>
            Les présentes Conditions Générales de Vente (ci-après « CGV ») définissent les modalités
            selon lesquelles Personal Regrets vend ses produits via son site internet.
            Veuillez les lire attentivement avant de passer commande.
          </p>
          <p>
            Toute commande passée sur le site implique l'acceptation sans réserve des présentes CGV
            en vigueur au jour de la commande.
          </p>
          <p>
            Personal Regrets se réserve le droit de modifier les présentes CGV à tout moment.
            Les CGV applicables sont celles publiées sur le site au moment de la validation de la
            commande.
          </p>
        </div>

        <section>
          <h3>1. Qui sommes-nous et comment nous contacter ?</h3>
          
          <h4>1.1 Qui sommes-nous</h4>
          <p>
            Personal Regrets,<br />
            Entreprise Individuelle (EI),<br />
            immatriculée en France,<br />
            Siège social : 3 rue Narcisse Fahy, 77515 Faremoutiers,<br />
            SIRET : 79516211400024,<br />
            Email : personalregrets@gmail.com.
          </p>
          <p className="legal-note">
            (Conformément aux articles L526-22 et suivants du Code de commerce, l'entrepreneur
            individuel exerce en son nom propre.)
          </p>

          <h4>1.2 Comment nous contacter</h4>
          <p>Vous pouvez nous contacter à tout moment via l'adresse email indiquée sur le site.</p>

          <h4>1.3 Comment nous vous contactons</h4>
          <p>Nous vous contacterons par email à l'adresse fournie lors de la commande.</p>
        </section>

        <section>
          <h3>2. Passer commande</h3>
          
          <h4>2.1 Processus de commande</h4>
          <p>
            Les commandes sont passées exclusivement en ligne.
            Avant validation, le client doit vérifier l'exactitude des informations saisies (produits, tailles,
            quantités, adresse).
          </p>

          <h4>2.2 Acceptation de la commande</h4>
          <p>
            La commande constitue une offre d'achat.
            Le contrat est conclu uniquement à compter de l'envoi de l'email confirmant l'expédition des
            produits.
          </p>

          <h4>2.3 Conditions pour commander</h4>
          <p>
            Le client déclare être âgé d'au moins 18 ans, disposer de la capacité juridique et d'un moyen
            de paiement valide.
          </p>
        </section>

        <section>
          <h3>3. Nos droits d'annulation de commande</h3>
          <p>Personal Regrets se réserve le droit d'annuler toute commande notamment en cas de :</p>
          <ul>
            <li>indisponibilité du produit,</li>
            <li>erreur manifeste de prix ou de description,</li>
            <li>informations de paiement ou de livraison incorrectes,</li>
            <li>suspicion de commande à des fins professionnelles ou de revente.</li>
          </ul>
          <p>En cas d'annulation, le client sera informé et intégralement remboursé.</p>
        </section>

        <section>
          <h3>4. Nos produits</h3>
          
          <h4>4.1 Nature des produits</h4>
          <p>Personal Regrets propose des vêtements de sport.</p>

          <h4>4.2 Description</h4>
          <p>
            Les descriptions et visuels sont fournis à titre indicatif.
            Des différences minimes (couleurs, rendu) peuvent exister selon les écrans utilisés.
          </p>
        </section>

        <section>
          <h3>5. Livraison</h3>
          
          <h4>5.1 Zone de livraison</h4>
          <p>Les produits sont livrés exclusivement en France métropolitaine, sauf indication contraire.</p>

          <h4>5.2 Frais de livraison</h4>
          <p>Les frais de livraison sont indiqués avant la validation de la commande.</p>

          <h4>5.3 Délais</h4>
          <p>Les délais sont donnés à titre indicatif et peuvent varier selon la période.</p>

          <h4>5.4 Force majeure</h4>
          <p>
            Personal Regrets ne peut être tenue responsable d'un retard ou d'une inexécution dus à un
            cas de force majeure.
          </p>
        </section>

        <section>
          <h3>6. Vos droits de résiliation et de rétractation</h3>
          
          <h4>6.1 Droit de rétractation légal</h4>
          <p>
            Conformément aux articles L221-18 à L221-28 du Code de la consommation, le client
            dispose d'un délai de 14 jours calendaires à compter de la réception du produit pour exercer
            son droit de rétractation.
          </p>

          <h4>6.2 Produits défectueux ou non conformes</h4>
          <p>
            Le client bénéficie des garanties légales de conformité et des vices cachés prévues par la
            loi.
          </p>
        </section>

        <section>
          <h3>7. Retours et remboursements</h3>
          
          <h4>7.1 Conditions de retour</h4>
          <p>Les produits retournés doivent être :</p>
          <ul>
            <li>non portés,</li>
            <li>non lavés,</li>
            <li>non endommagés,</li>
            <li>avec étiquettes intactes,</li>
            <li>dans leur emballage d'origine.</li>
          </ul>

          <h4>7.2 Frais de retour</h4>
          <p>
            Les frais de retour sont à la charge exclusive de l'acheteur,
            sauf en cas d'erreur ou de défaut imputable à Personal Regrets.
          </p>

          <h4>7.3 Remboursement</h4>
          <p>
            Le remboursement est effectué dans un délai maximal de 14 jours à compter de la réception
            et de la vérification des produits retournés, via le moyen de paiement initial.
          </p>
        </section>

        <section>
          <h3>8. Nos droits de résiliation du contrat</h3>
          <p>
            Personal Regrets peut résilier le contrat si le client ne fournit pas les informations
            nécessaires à la livraison ou empêche l'exécution normale du contrat.
          </p>
        </section>

        <section>
          <h3>9. Prix et paiement</h3>
          <p>
            Les prix sont indiqués en euros (€) TTC.
            Le paiement est sécurisé et effectué via Stripe (carte bancaire et moyens proposés par
            Stripe).
          </p>
          <p>
            En cas d'erreur manifeste de prix, Personal Regrets se réserve le droit d'annuler la
            commande et de rembourser le client.
          </p>
        </section>

        <section>
          <h3>10. Codes promotionnels</h3>
          <p>Les codes promotionnels :</p>
          <ul>
            <li>sont valables pour une durée limitée,</li>
            <li>ne sont pas cumulables,</li>
            <li>ne s'appliquent pas aux frais de livraison,</li>
            <li>ne donnent lieu à aucun remboursement en cas de retour.</li>
          </ul>
        </section>

        <section>
          <h3>11. Responsabilité</h3>
          <p>
            Les produits sont destinés à un usage personnel.
            Personal Regrets ne saurait être tenue responsable des dommages indirects résultant de
            l'utilisation des produits.
          </p>
        </section>

        <section>
          <h3>12. Données personnelles</h3>
          <p>
            Les données personnelles sont traitées conformément à la Politique de confidentialité
            disponible sur le site, en application du RGPD.
          </p>
        </section>

        <section>
          <h3>13. Droit applicable et litiges</h3>
          <p>
            Les présentes CGV sont soumises au droit français.
            En cas de litige, le client peut recourir gratuitement à un médiateur de la consommation
            avant toute action judiciaire ou saisir le tribunal compétent.
          </p>
        </section>

        <section className="legal-references">
          <h3>Sources juridiques officielles</h3>
          <ul>
            <li>
              <strong>Code de la consommation – Articles L221-18 à L221-28</strong><br />
              Direction de l'information légale et administrative – Légifrance<br />
              <a href="https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006069565/LEGISCTA000032227088/" target="_blank" rel="noopener noreferrer">
                https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006069565/LEGISCTA000032227088/
              </a>
            </li>
            <li>
              <strong>DGCCRF – Vente à distance (2024)</strong><br />
              Ministère de l'Économie<br />
              <a href="https://www.economie.gouv.fr/dgccrf/vente-distance" target="_blank" rel="noopener noreferrer">
                https://www.economie.gouv.fr/dgccrf/vente-distance
              </a>
            </li>
            <li>
              <strong>Directive 2011/83/UE – Droits des consommateurs</strong><br />
              Parlement européen<br />
              <a href="https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32011L0083" target="_blank" rel="noopener noreferrer">
                https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32011L0083
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Terms;
